import React, { useEffect, useState } from 'react';

export default function InstallPrompt() {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(() => window.matchMedia?.('(display-mode: standalone)').matches);

  useEffect(() => {
    const ready = event => { event.preventDefault(); setPrompt(event); };
    const done = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener('beforeinstallprompt', ready);
    window.addEventListener('appinstalled', done);
    return () => {
      window.removeEventListener('beforeinstallprompt', ready);
      window.removeEventListener('appinstalled', done);
    };
  }, []);

  if (!prompt || installed) return null;
  const install = async () => {
    await prompt.prompt();
    await prompt.userChoice;
    setPrompt(null);
  };
  return <button type="button" onClick={install}
    className="fixed bottom-24 right-4 z-[110] flex items-center gap-2 rounded-2xl border border-white/15 bg-[#2d1c19]/95 px-4 py-3 text-sm font-extrabold text-white shadow-2xl backdrop-blur-xl md:bottom-5">
    <i className="ti ti-download text-lg text-[#b99bf8]" /> Instalar BlopBoru
  </button>;
}
